/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderParticipantStatus } from './LadderParticipantStatus';
import {
    LadderParticipantStatusFromJSON,
    LadderParticipantStatusFromJSONTyped,
    LadderParticipantStatusToJSON,
    LadderParticipantStatusToJSONTyped,
} from './LadderParticipantStatus';

/**
 * Full participant record for ladder standings
 * @export
 * @interface LadderParticipant
 */
export interface LadderParticipant {
    /**
     * 
     * @type {string}
     * @memberof LadderParticipant
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    updatedAt: number;
    /**
     * ID of the ladder
     * @type {string}
     * @memberof LadderParticipant
     */
    ladderId: string;
    /**
     * User's odId (OpenID)
     * @type {string}
     * @memberof LadderParticipant
     */
    odId: string;
    /**
     * Team ID for team-based ladders
     * @type {string}
     * @memberof LadderParticipant
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof LadderParticipant
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    rank: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    rating: number;
    /**
     * For Glicko/TrueSkill rating systems
     * @type {number}
     * @memberof LadderParticipant
     */
    ratingDeviation?: number;
    /**
     * For Glicko-2 rating system
     * @type {number}
     * @memberof LadderParticipant
     */
    volatility?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    wins: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    losses: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    draws: number;
    /**
     * Positive = win streak, negative = loss streak
     * @type {number}
     * @memberof LadderParticipant
     */
    streak: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    peakRating: number;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    gamesPlayed: number;
    /**
     * 
     * @type {boolean}
     * @memberof LadderParticipant
     */
    isProvisional: boolean;
    /**
     * Last activity timestamp (epoch ms)
     * @type {number}
     * @memberof LadderParticipant
     */
    lastActive: number;
    /**
     * When rating decay will begin (epoch ms)
     * @type {number}
     * @memberof LadderParticipant
     */
    decayStartsAt?: number;
    /**
     * Accumulated decay not yet applied
     * @type {number}
     * @memberof LadderParticipant
     */
    pendingDecay: number;
    /**
     * 
     * @type {LadderParticipantStatus}
     * @memberof LadderParticipant
     */
    status: LadderParticipantStatus;
    /**
     * 
     * @type {number}
     * @memberof LadderParticipant
     */
    joinedAt: number;
}



/**
 * Check if a given object implements the LadderParticipant interface.
 */
export function instanceOfLadderParticipant(value: object): value is LadderParticipant {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('ladderId' in value) || value['ladderId'] === undefined) return false;
    if (!('odId' in value) || value['odId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('rating' in value) || value['rating'] === undefined) return false;
    if (!('wins' in value) || value['wins'] === undefined) return false;
    if (!('losses' in value) || value['losses'] === undefined) return false;
    if (!('draws' in value) || value['draws'] === undefined) return false;
    if (!('streak' in value) || value['streak'] === undefined) return false;
    if (!('peakRating' in value) || value['peakRating'] === undefined) return false;
    if (!('gamesPlayed' in value) || value['gamesPlayed'] === undefined) return false;
    if (!('isProvisional' in value) || value['isProvisional'] === undefined) return false;
    if (!('lastActive' in value) || value['lastActive'] === undefined) return false;
    if (!('pendingDecay' in value) || value['pendingDecay'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('joinedAt' in value) || value['joinedAt'] === undefined) return false;
    return true;
}

export function LadderParticipantFromJSON(json: any): LadderParticipant {
    return LadderParticipantFromJSONTyped(json, false);
}

export function LadderParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderParticipant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'ladderId': json['ladderId'],
        'odId': json['odId'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'displayName': json['displayName'],
        'rank': json['rank'],
        'rating': json['rating'],
        'ratingDeviation': json['ratingDeviation'] == null ? undefined : json['ratingDeviation'],
        'volatility': json['volatility'] == null ? undefined : json['volatility'],
        'wins': json['wins'],
        'losses': json['losses'],
        'draws': json['draws'],
        'streak': json['streak'],
        'peakRating': json['peakRating'],
        'gamesPlayed': json['gamesPlayed'],
        'isProvisional': json['isProvisional'],
        'lastActive': json['lastActive'],
        'decayStartsAt': json['decayStartsAt'] == null ? undefined : json['decayStartsAt'],
        'pendingDecay': json['pendingDecay'],
        'status': LadderParticipantStatusFromJSON(json['status']),
        'joinedAt': json['joinedAt'],
    };
}

export function LadderParticipantToJSON(json: any): LadderParticipant {
    return LadderParticipantToJSONTyped(json, false);
}

export function LadderParticipantToJSONTyped(value?: LadderParticipant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'ladderId': value['ladderId'],
        'odId': value['odId'],
        'teamId': value['teamId'],
        'displayName': value['displayName'],
        'rank': value['rank'],
        'rating': value['rating'],
        'ratingDeviation': value['ratingDeviation'],
        'volatility': value['volatility'],
        'wins': value['wins'],
        'losses': value['losses'],
        'draws': value['draws'],
        'streak': value['streak'],
        'peakRating': value['peakRating'],
        'gamesPlayed': value['gamesPlayed'],
        'isProvisional': value['isProvisional'],
        'lastActive': value['lastActive'],
        'decayStartsAt': value['decayStartsAt'],
        'pendingDecay': value['pendingDecay'],
        'status': LadderParticipantStatusToJSON(value['status']),
        'joinedAt': value['joinedAt'],
    };
}

